import { showError } from './utils';
import axios from 'axios';

// 创建API实例，使用本地代理服务器
export const API = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3035',
  timeout: 30000, // 30秒超时
});

// 创建代理请求的辅助函数
export const createProxyRequest = (serviceKey, path, options = {}) => {
  const encodedServiceKey = encodeURIComponent(serviceKey);
  const proxyPath = `/api/proxy/${encodedServiceKey}${path}`;
  
  return API.request({
    url: proxyPath,
    ...options
  });
};

// 响应拦截器
API.interceptors.response.use(
  (response) => response,
  (error) => {
    showError(error);
    return Promise.reject(error);
  }
);

// 请求拦截器，用于调试
API.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('API Request:', config.method?.toUpperCase(), config.url);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
